function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.6.6h10.8v10.8H.6z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.6 3.3L4.65 8.25 2.4 6"
}));

function SvgFeatherCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFeatherCheck;